/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EnrollmentCalendarItem } from './EnrollmentCalendarItem';
import {
    EnrollmentCalendarItemFromJSON,
    EnrollmentCalendarItemFromJSONTyped,
    EnrollmentCalendarItemToJSON,
    EnrollmentCalendarItemToJSONTyped,
} from './EnrollmentCalendarItem';

/**
 * 
 * @export
 * @interface WidgetDataEnrollmentsCalendarWidgetData
 */
export interface WidgetDataEnrollmentsCalendarWidgetData {
    /**
     * 
     * @type {string}
     * @memberof WidgetDataEnrollmentsCalendarWidgetData
     */
    $type?: WidgetDataEnrollmentsCalendarWidgetDataTypeEnum;
    /**
     * 
     * @type {Array<EnrollmentCalendarItem>}
     * @memberof WidgetDataEnrollmentsCalendarWidgetData
     */
    items: Array<EnrollmentCalendarItem>;
}


/**
 * @export
 */
export const WidgetDataEnrollmentsCalendarWidgetDataTypeEnum = {
    EnrollmentCalendar: 'enrollment-calendar'
} as const;
export type WidgetDataEnrollmentsCalendarWidgetDataTypeEnum = typeof WidgetDataEnrollmentsCalendarWidgetDataTypeEnum[keyof typeof WidgetDataEnrollmentsCalendarWidgetDataTypeEnum];


/**
 * Check if a given object implements the WidgetDataEnrollmentsCalendarWidgetData interface.
 */
export function instanceOfWidgetDataEnrollmentsCalendarWidgetData(value: object): value is WidgetDataEnrollmentsCalendarWidgetData {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function WidgetDataEnrollmentsCalendarWidgetDataFromJSON(json: any): WidgetDataEnrollmentsCalendarWidgetData {
    return WidgetDataEnrollmentsCalendarWidgetDataFromJSONTyped(json, false);
}

export function WidgetDataEnrollmentsCalendarWidgetDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): WidgetDataEnrollmentsCalendarWidgetData {
    if (json == null) {
        return json;
    }
    return {
        
        '$type': json['$type'] == null ? undefined : json['$type'],
        'items': ((json['items'] as Array<any>).map(EnrollmentCalendarItemFromJSON)),
    };
}

export function WidgetDataEnrollmentsCalendarWidgetDataToJSON(json: any): WidgetDataEnrollmentsCalendarWidgetData {
    return WidgetDataEnrollmentsCalendarWidgetDataToJSONTyped(json, false);
}

export function WidgetDataEnrollmentsCalendarWidgetDataToJSONTyped(value?: WidgetDataEnrollmentsCalendarWidgetData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        '$type': value['$type'],
        'items': ((value['items'] as Array<any>).map(EnrollmentCalendarItemToJSON)),
    };
}

